import {
    FETCH_ALERTS,
    FETCH_ALERTS_FAIL,
    FETCH_ALERTS_SUCCESS,
    RESET_ALERTS
} from './actionTypes';

export const fetchAlerts = args => ({
    type: FETCH_ALERTS,
    payload: args
});

export const fetchAlertsSuccess = response => ({
    type: FETCH_ALERTS_SUCCESS,
    payload: response
});

export const fetchAlertsFail = error => ({
    type: FETCH_ALERTS_FAIL,
    payload: error
});

export const resetAlerts = () => ({
    type: RESET_ALERTS
});
